
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    label: String,
    value: String,
    featured: Boolean,
  },
})
export default class MetricStat extends Vue {}
